// src/pages/Workers/AllWorkers.jsx
import { getPositionWithFallback, useLocationPermissionSync } from "../../../../utils/getPositionWithFallback";
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Button,
  useMediaQuery,
  CircularProgress,
  Pagination,
  Typography,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

import { useTheme } from "../../../../contexts/ThemeContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SearchIcon from "@mui/icons-material/Search";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import { useTranslation } from "react-i18next";
import { decryptToken } from "../../../../Utlis/Encryption";
import CustomText, { textStyles } from "../../../../components/CustomText";
import ExportDropdown from "../../../../components/ExportDropdown";
import SearchInput from "../../../../components/SearchInput";
import StatusDropdown from "../../../../components/StatusDropdown";
import AddWorkers from "./AddWorker";
import WorkerDetails from "./WorkerDetails";
import { BASE_URL } from "../../../../components/BaseUrl";
import { useSelector } from "react-redux";
import FilterDrawer from "./FilterWorkers";
import empty from "../../../../assets/empty.png";
import WorkerStatusDropdown from "../../../../components/workerUpdateStatus";
import {toast} from "react-hot-toast";
import ExportWorkersPDF from "./workersPdf";
import ExportWorkersExcel from "./workersExcel";
import { pdf } from "@react-pdf/renderer";
import DeleteWorkerModal from "./DeleteModal";
import WorkerPins from "./WorkerPins";
import { useNavigate } from "react-router-dom";
import EarlyOutIcon from "../../../../assets/StatusIcons/EarlyOutIcon.svg";
import LeaveIcon from "../../../../assets/StatusIcons/LeaveIcon.svg";
import { useCompanyProfile } from "../../../../components/CompanyProfile";
import DashboardCard from "../../../../components/Cards/DashboardCard";
import PresentIcon from "../../../../assets/StatusIcons/PresentIcon.svg";
import AbsentIcon from "../../../../assets/StatusIcons/AbsentIcon.svg";
import HalfLeaveIcon from "../../../../assets/StatusIcons/HalfLeaveIcon.svg";
import back from "../../../../assets/back.svg";
import { useLocation } from 'react-router-dom';
import clockout from "../../../../assets/Dashboard/clockout.svg";
import breakstart from "../../../../assets/Dashboard/breakstart.svg";
import breakend from "../../../../assets/Dashboard/breakend.svg";
import ontimeclockin from "../../../../assets/Dashboard/ontimeclockin.svg";
import lateclockin from "../../../../assets/Dashboard/lateclockin.svg";
import lateclockout from "../../../../assets/Dashboard/lateclockout.svg";
import activeemployee from "../../../../assets/Dashboard/activeemployee.svg";

import pendingworkers from "../../../../assets/Dashboard/pendingworkers.svg";
import ontimeworker from "../../../../assets/Dashboard/ontimeworker.svg";
import presenttodayworker from "../../../../assets/Dashboard/presenttodayworker.svg";
import absentworker from "../../../../assets/Dashboard/absentworker.svg";
import lateworker from "../../../../assets/Dashboard/lateworker.svg";
import pendingtask from '../../../../assets/Dashboard/pendingtask.svg';
import pendingrequests from "../../../../assets/Dashboard/pendingrequests.svg";
import pendingdocuments from "../../../../assets/Dashboard/pendingdocuments.svg";
import pendingexpense  from "../../../../assets/Dashboard/pendingexpense.svg";
import icon1 from "../../../../assets/LastetIcons/icon1.svg";
import icon2 from "../../../../assets/LastetIcons/icon2.svg";
import icon3 from "../../../../assets/LastetIcons/icon3.svg"
import icon4 from "../../../../assets/LastetIcons/icon4.svg"
import icon5 from "../../../../assets/LastetIcons/icon5.svg"
import icon6 from "../../../../assets/LastetIcons/icon6.svg"
import icon7 from "../../../../assets/LastetIcons/icon7.svg"
import icon8 from "../../../../assets/LastetIcons/icon8.svg"
import icon9 from "../../../../assets/LastetIcons/icon9.svg"

import icon10 from "../../../../assets/LastetIcons/icon10.svg"
import icon11 from "../../../../assets/LastetIcons/icon11.svg"

import icon12 from "../../../../assets/LastetIcons/icon12.svg"
import icon13 from "../../../../assets/LastetIcons/icon13.svg"
import icon14 from "../../../../assets/LastetIcons/icon14.svg"
import icon15 from "../../../../assets/LastetIcons/icon15.svg"
import icon16 from "../../../../assets/LastetIcons/icon16.svg"
import icon17 from "../../../../assets/LastetIcons/icon17.svg"

import icon18 from "../../../../assets/LastetIcons/icon18.svg"
import icon19 from "../../../../assets/LastetIcons/icon19.svg"
import icon20 from "../../../../assets/LastetIcons/icon20.svg"
import {
  GoogleMap,
  Marker,
  Circle,
  useJsApiLoader,
} from "@react-google-maps/api";
import { MAPS_API_KEY } from "../../../../components/mapKey";
import { getGoogleMapsPinIconFromHex } from "../../../../constants/statusPalette";
import {
  convertLocalDateTimeToUTC,
  convertUTCToLocalDateTime,
} from "../../../../components/dateTimeUtils";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const AllWorkers = () => {
  const { t } = useTranslation();
  const { primaryColor, secondaryColor, primaryTextColor, secondaryTextColor } = useTheme();
const location = useLocation();
  const fromDashboard = location.state?.fromDashboard;
  // state
  const [tab, setTab] = useState(0);
  const [workers, setWorkers] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true); // big loader first load
  const [tableLoading, setTableLoading] = useState(false);    // small loader on interactions
  const [errorMsg, setErrorMsg] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [selectedMapWorkerId, setSelectedMapWorkerId] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [workerToEdit, setWorkerToEdit] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
const navigate=useNavigate()
  // sorting
  const [sortBy, setSortBy] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");

  // filters
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filters, setFilters] = useState({ status: "", startDate: "",
      department_id: [],
  worker_ids: [],
  salary: "",
  shift: "",
  work_hours: "",
   });
const isFilterApplied = Boolean(
  filters.status ||
  filters.startDate ||
  (filters.department_id && filters.department_id.length) ||
  (filters.worker_ids && filters.worker_ids.length) ||
  filters.salary ||
  filters.shift ||
  filters.work_hours
);const { company } = useSelector((state) => state.auth);
const companyId = company?.id;
console.log(companyId)
  // auth
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const isMobile = useMediaQuery("(max-width:768px)");
  // const firstLoadRef = useRef(true);

  // map UI column keys to backend fields
  const columnMap = {
    id: "id",
    name: "first_name",
    created_at: "created_at",
  };

  // kebab menu state (per-row)
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuWorker, setMenuWorker] = useState(null);
  
  // Schedule modal state
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [pendingWorker, setPendingWorker] = useState(null);
  const [pendingNewStatus, setPendingNewStatus] = useState(null);
  const [scheduleData, setScheduleData] = useState(null);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [scheduleForm, setScheduleForm] = useState({
    workingDays: [],
    startTime: "",
    endTime: "",
    graceMinutes: "",
    breakMinutes: "",
    locationName: "",
    radiusMeters: 100,
  });
  const [currentLocation, setCurrentLocation] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [address, setAddress] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const fullDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const convertUTCToLocalInputTime = (utcTimeValue) => {
    if (!utcTimeValue || utcTimeValue === "-") return "";

    const localTime = convertUTCToLocalDateTime(utcTimeValue, {
      locale: "en-GB",
      formatOptions: { hour: "2-digit", minute: "2-digit", hour12: false },
    });

    if (!localTime || localTime === "—") return "";
    return localTime.trim().slice(0, 5);
  };

  const convertLocalTimeToUTCTimeOnly = (timeStr) => {
    if (!timeStr) return "";

    const utcISO = convertLocalDateTimeToUTC(timeStr);
    if (!utcISO) return "";

    return new Date(utcISO).toISOString().slice(11, 16);
  };
  
  // Reverse geocode function using Google Maps
  const fetchAddress = useCallback(([lat, lng]) => {
    if (!window.google) return;
    
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        setAddress(results[0].formatted_address);
      } else {
        setAddress("Address not found");
      }
    });
  }, []);

  // Search location function using Google Places
  const handleSearchSelect = (suggestion) => {
    if (!window.google) return;
    
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: suggestion.place_id }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        const coords = [location.lat(), location.lng()];
        setCurrentLocation(coords);
        fetchAddress(coords);
        setSearchQuery(results[0].formatted_address);
        setSearchSuggestions([]);
      } else {
        toast.error("Location not found");
      }
    });
  };

  // Auto-complete search suggestions
  useEffect(() => {
    if (!searchQuery.trim() || !window.google) {
      setSearchSuggestions([]);
      return;
    }

    const timeout = setTimeout(() => {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions({ input: searchQuery }, (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setSearchSuggestions(predictions || []);
        } else {
          setSearchSuggestions([]);
        }
      });
    }, 400);

    return () => clearTimeout(timeout);
  }, [searchQuery]);

  // Get current location
  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      getPositionWithFallback(
        (pos) => {
          const coords = [pos.coords.latitude, pos.coords.longitude];
          setCurrentLocation(coords);
          fetchAddress(coords);
        },
        () => {
          toast.error("Unable to get current location");
        }
      );
    } else {
      toast.error("Geolocation is not supported");
    }
  };

  // Reflect browser location allow/block changes live (no refresh needed).
  useLocationPermissionSync({
    enabled: scheduleModalOpen,
    onGranted: () => {
      if (!currentLocation) handleGetCurrentLocation();
    },
    onDenied: () => toast.error("Unable to get current location"),
  });

  // Fetch address when location changes
  useEffect(() => {
    if (currentLocation) {
      fetchAddress(currentLocation);
    }
  }, [currentLocation, fetchAddress]);

  // Auto-fetch current location when schedule modal opens
  useEffect(() => {
    if (scheduleModalOpen && !currentLocation) {
      handleGetCurrentLocation();
    }
  }, [scheduleModalOpen]);

  const handleMenuOpen = (event, worker) => {
    setMenuAnchor(event.currentTarget);
    setMenuWorker(worker);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setMenuWorker(null);
  };

  const handleView = () => {
    if (menuWorker) setSelectedWorker(menuWorker);
    handleMenuClose();
  };

  const handleEdit = () => {
    if (menuWorker) {
      setWorkerToEdit(menuWorker);
      setOpenDrawer(true);
    }
    handleMenuClose();
  };

  const handleChat = () => {
    if (!menuWorker) return;

      // ✅ Check worker status before allowing chat
  if ((menuWorker.status || "").toLowerCase() !== "active") {
 toast.error(t("onlyActive"));
    handleMenuClose();
    return;
  }


    navigate("/messages/worker", {
      state: {
        openChat: {
          receiverId: menuWorker.id,
          receiverRole: "worker",
          receiverName: menuWorker.name,
          receiverEmail: menuWorker.email,
        },
      },
    });

    handleMenuClose();
  };

  // Handle row click to show worker on map
  const handleRowClick = (worker) => {
    setSelectedMapWorkerId(worker.id);
  };

  // Clear map filter
  const handleClearMapFilter = () => {
    setSelectedMapWorkerId(null);
  };

// keep your same state
const firstLoadRef = useRef(true);
const formatSalary = (value) => {
  if (!value || isNaN(value)) return "—";

  const num = Number(value);

  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";

  return num.toFixed(2);
};

const formatDailyHoursDisplay = (dailyHours) => {
  if (dailyHours === null || dailyHours === undefined || dailyHours === "" || dailyHours === "-") {
    return "—";
  }
  const hours = Number(dailyHours);
  if (Number.isNaN(hours)) return "—";

  const totalMinutes = Math.max(0, Math.round(hours * 60));
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  if (h > 0 && m > 0) return `${h}h ${m} min`;
  if (h > 0) return `${h}h`;
  return `${m}min`;
};


const fetchWorkers = async ({ initial = false } = {}) => {
  try {
    if (initial) setInitialLoading(true);
    else setTableLoading(true);

    setErrorMsg("");

    const params = new URLSearchParams({
      page: String(page + 1),
      limit: String(pageSize),
      sort_by: columnMap[sortBy] || sortBy,
      sort_order: sortOrder,
    });

    if (searchTerm) params.set("search", searchTerm);
    if (filters.status) params.set("status", filters.status);
    if (filters.startDate) params.set("startDate", filters.startDate);

// department_id: array → multiple query params
if (Array.isArray(filters.department_id) && filters.department_id.length > 0) {
  filters.department_id.forEach((id) => {
    if (id !== null && id !== undefined && id !== "") {
      params.append("department_id", String(id));
    }
  });
}

// worker_ids: array → multiple query params
if (Array.isArray(filters.worker_ids) && filters.worker_ids.length > 0) {
  filters.worker_ids.forEach((id) => {
    if (id !== null && id !== undefined && id !== "") {
      params.append("worker_ids", String(id));
    }
  });
}

// shift: string
if (filters.shift) params.set("shift", filters.shift);

// salary: number/string
if (filters.salary !== "" && filters.salary !== null && filters.salary !== undefined) {
  params.set("salary", String(filters.salary));
}

// work_hours: number/string
if (filters.work_hours !== "" && filters.work_hours !== null && filters.work_hours !== undefined) {
  params.set("work_hours", String(filters.work_hours));


    }  
        const url = `${BASE_URL}/company-admins/workers?company_id=${companyId}&${params.toString()}`;
    console.log("📡 Final request:", url);


    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
    });

    const json = await res.json();
    console.log("📊 API response:", json);

    if (json?.error) {
      const msg = (json?.message || "").toString();
      const msgLower = msg.toLowerCase();
      const looksLikeEmpty =
        res.status === 404 ||
        (msgLower.includes("no") && msgLower.includes("worker")) ||
        (msgLower.includes("worker") && msgLower.includes("not found")) ||
        // Some environments return a DB error when there are no workers configured yet.
        // Don't show raw SQL errors to the user; treat it as empty state.
        msgLower.includes("wwl.radius_meters") ||
        (msgLower.includes("radius_meters") && msgLower.includes("does not exist"));

      // "No workers" should behave like empty state (header + add button still visible)
      if (looksLikeEmpty) {
        setErrorMsg("");
      } else {
        setErrorMsg(msg || "Failed to fetch workers.");
      }

      setWorkers([]);
      setTotalPages(1);
      return;
    }

    if (Array.isArray(json?.data?.workers)) {
      const mapped = json.data.workers.map((w) => ({
        id: w.id,
        name: `${w.first_name} ${w.last_name}`,
        email: w.email,
        phone: w.phone,
        department: w.department_name || "-",
        department_id: w.department_id || null,
        type: w.employee_type || "-",
        shift: w.shift_schedule || "-",
           salary: formatSalary(w.salary),

  workHours: formatDailyHoursDisplay(
          w.daily_hours ?? w.work_hours??  w.attendanceSettings?.schedule?.dailyHours
        ),
        status: w.status || "-",
        date: w.created_at
          ? new Date(w.created_at).toLocaleString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "—",
      }));
      setWorkers(mapped);
      setTotalPages(json.data.pagination?.pages || 1);
    } else {
      setWorkers([]);
      setTotalPages(1);
    }
  } catch (err) {
    console.error("❌ Error fetching workers:", err);
    setErrorMsg("Network error while fetching workers.");
  } finally {
    if (initial) setInitialLoading(false);
    else setTableLoading(false);
  }
};

useEffect(() => {
  if (!decryptedToken) {
    setInitialLoading(false);
    setErrorMsg("Missing auth token.");
    return;
  }

  // Debounce search to avoid too many API calls
  const timeoutId = setTimeout(() => {
    const isInitial = firstLoadRef.current;
    fetchWorkers({ initial: isInitial });
    if (isInitial) firstLoadRef.current = false;
  }, searchTerm ? 500 : 0); // 500ms delay for search, immediate for other changes

  return () => clearTimeout(timeoutId);
}, [decryptedToken, page, pageSize, searchTerm, sortBy, sortOrder, filters]);

// Reset to page 1 when search term changes
useEffect(() => {
  if (searchTerm) {
    setPage(0);
  }
}, [searchTerm]);

  // useEffect(() => {
  //   if (!decryptedToken) {
  //     setInitialLoading(false);
  //     setErrorMsg("Missing auth token.");
  //     return;
  //   }
  //   const isInitial = firstLoadRef.current;
  //   fetchWorkers({ initial: isInitial });
  //   if (isInitial) firstLoadRef.current = false;
  // }, [decryptedToken, page, pageSize, searchTerm, sortBy, sortOrder, filters, fetchWorkers]);

// Handle schedule confirmation and status update
const handleScheduleConfirm = async () => {
  if (!pendingWorker || !pendingNewStatus) return;

  if (scheduleForm.workingDays.length === 0) {
    toast.error("Please select at least one working day");
    return;
  }

  setTableLoading(true);
  try {
    // Save schedule if form has data (working days selected)
    if (scheduleForm.workingDays.length > 0) {
      const payload = {
        schedule: {
          days: scheduleForm.workingDays,
          start: convertLocalTimeToUTCTimeOnly(scheduleForm.startTime),
          end: convertLocalTimeToUTCTimeOnly(scheduleForm.endTime),
          breakPolicy: { unpaid: Number(scheduleForm.breakMinutes) || 0 },
          graceMinutes: Number(scheduleForm.graceMinutes) || 0,
        },
        location: {
          lat: currentLocation ? currentLocation[0] : null,
          lng: currentLocation ? currentLocation[1] : null,
          radiusMeters: Number(scheduleForm.radiusMeters) || 100,
          locationName: scheduleForm.locationName,
        },
      };

      const scheduleRes = await fetch(
        `${BASE_URL}/company-admins/workers/${pendingWorker.id}/attendance-settings`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!scheduleRes.ok) {
        const scheduleJson = await scheduleRes.json();
        toast.error(scheduleJson.message || "Failed to save schedule");
        setTableLoading(false);
        return;
      }
    }

    // Update status
    await updateWorkerStatus(pendingWorker.id, pendingNewStatus);

    // Close modal and reset state
    setScheduleModalOpen(false);
    setPendingWorker(null);
    setPendingNewStatus(null);
    setScheduleData(null);
    setScheduleForm({
      workingDays: [],
      startTime: "",
      endTime: "",
      graceMinutes: "",
      breakMinutes: "",
      locationName: "",
      radiusMeters: 100,
    });
    setCurrentLocation(null);
    setSearchQuery("");
    setAddress("");
    setSearchOpen(false);
  } catch (err) {
    console.error("Error confirming schedule:", err);
    toast.error("Failed to save schedule and update status");
    setTableLoading(false);
  }
};

const handleSort = (column) => {
  const apiColumn = columnMap[column] || column;

  let nextOrder = "asc";
  if (sortBy === apiColumn) {
    nextOrder = sortOrder === "asc" ? "desc" : "asc";
  }

  setSortBy(apiColumn);
  setSortOrder(nextOrder);

  console.log(`🔄 Sorting changed: ${apiColumn} → ${nextOrder}`);
};




  const HaederStyles = {
    color: "#44546F",
    fontSize: "14px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
      whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
    cursor: "pointer",
  };
  const DataStyles = {
    color: "#172B4D",
    fontSize: "12px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
      whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
  };
  const tabStyle = {
    fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    textTransform: "none",
    color: "#44546F",
    minHeight: "unset",
    padding: "6px 12px",
    paddingBottom: "4px",
    mt: 1,
  };


const TAB_STATUS = ["", "email_pending", "active", "inactive"];
const handleTabChange = (_e, newValue) => {
  setTab(newValue);
  const nextStatus = TAB_STATUS[newValue] ?? "";
  setFilters(prev => ({ ...prev, status: nextStatus }));
  setPage(0);
};
useEffect(() => {
  // reflect external status changes (from drawer) onto the selected tab
  const idx = TAB_STATUS.indexOf((filters.status || "").toLowerCase());
  setTab(idx >= 0 ? idx : 0);
}, [filters.status]);


// inside AllWorkers
const handleStatusUpdate = async (workerId, newStatus, currentStatus) => {
  const normalizedCurrentStatus = (currentStatus || "").toLowerCase();
  const normalizedNewStatus = (newStatus || "").toLowerCase();

  // Require schedule setup when activating workers from pending/invited.
  if (
    (normalizedCurrentStatus === "pending" ||
      normalizedCurrentStatus === "invited") &&
    normalizedNewStatus === "active"
  ) {
    // Find the worker to get their department_id
    const worker = workers.find((w) => w.id === workerId);
    if (worker) {
      setPendingWorker(worker);
      setPendingNewStatus(normalizedNewStatus);
      setScheduleModalOpen(true);
      fetchWorkerSchedule(workerId, worker.department_id);
      return; // Don't update status yet, wait for modal confirmation
    }
  }

  // For other status changes, update directly
  await updateWorkerStatus(workerId, normalizedNewStatus);
};

// Separate function to actually update the status
const updateWorkerStatus = async (workerId, newStatus) => {
  setTableLoading(true);
  try {
    const res = await fetch(`${BASE_URL}/company-admins/workers/${workerId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: JSON.stringify({ status: newStatus }),
    });

    const json = await res.json();

    if (res.ok && !json.error) {
      toast.success(t("toast.statusUpdated"));
      await fetchWorkers({ initial: false });
    } else {
      toast.error(json.message || t("toast.statusUpdateFailed"));
      setTableLoading(false);
    }
  } catch (err) {
    console.error("Error updating worker status:", err);
    toast.error(t("toast.statusUpdateNetworkError"));
    setTableLoading(false);
  }
};

// Fetch worker schedule or department schedule
const fetchWorkerSchedule = async (workerId, departmentId) => {
  setScheduleLoading(true);
  try {
    // First, try to fetch worker's schedule
    const workerRes = await fetch(
      `${BASE_URL}/company-admins/workers/${workerId}/attendance-settings`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    const workerJson = await workerRes.json();
    
    if (workerRes.ok && !workerJson.error && workerJson.data?.hasSettings) {
      // Worker has schedule
      const { schedule, location } = workerJson.data;
      setScheduleData({ schedule, location, source: "worker" });
      console.log("Worker schedule:", workerJson.data);
      // Populate form
      if (schedule) {
        setScheduleForm({
          workingDays: schedule.days || [],
          startTime: convertUTCToLocalInputTime(schedule.start),
          endTime: convertUTCToLocalInputTime(schedule.end),
          graceMinutes: schedule.graceMinutes?.toString() || "",
          breakMinutes: schedule.breakPolicy?.unpaid?.toString() || "",
          locationName: location?.locationName || "",
          radiusMeters: location?.radiusMeters || 100,
        });
      }
      
      if (location?.lat && location?.lng) {
        setCurrentLocation([location.lat, location.lng]);
      }
    } else if (departmentId) {
      // Worker doesn't have schedule, try department schedule
      const deptRes = await fetch(
        `${BASE_URL}/company-admins/departments/${departmentId}/attendance-settings`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      const deptJson = await deptRes.json();
      
      if (deptRes.ok && !deptJson.error && deptJson.data?.hasSettings) {
        const { schedule, location } = deptJson.data;
        setScheduleData({ schedule, location, source: "department" });
        console.log("Department schedule:", deptJson.data);
        // Populate form
        if (schedule) {
          setScheduleForm({
            workingDays: schedule.days || [],
            startTime: convertUTCToLocalInputTime(schedule.start),
            endTime: convertUTCToLocalInputTime(schedule.end),
            graceMinutes: schedule.graceMinutes?.toString() || "",
            breakMinutes: schedule.breakPolicy?.unpaid?.toString() || "",
            locationName: location?.locationName || "",
            radiusMeters: location?.radiusMeters || 100,
          });
        }
        
        if (location?.lat && location?.lng) {
          setCurrentLocation([location.lat, location.lng]);
        }
      } else {
        // No schedule found
        setScheduleData(null);
        setScheduleForm({
          workingDays: [],
          startTime: "",
          endTime: "",
          graceMinutes: "",
          breakMinutes: "",
          locationName: "",
          radiusMeters: 100,
        });
      }
    } else {
      setScheduleData(null);
    }
  } catch (err) {
    console.error("Error fetching schedule:", err);
    setScheduleData(null);
  } finally {
    setScheduleLoading(false);
  }
};



const fetchAllWorkers = async () => {
  try {
    const queryParams = new URLSearchParams({
      no_pagination: "true",
      sort_by: sortBy || "created_at",
      sort_order: (sortOrder || "DESC").toUpperCase(),
      company_id: companyId,
    });

    if (searchTerm) queryParams.append("search", searchTerm);
    if (filters.status) queryParams.append("status", filters.status);
    if (filters.startDate) queryParams.append("startDate", filters.startDate);


if (Array.isArray(filters.department_id) && filters.department_id.length > 0) {
  filters.department_id.forEach((id) => {
    if (id !== null && id !== undefined && id !== "") {
      queryParams.append("department_id", String(id));
    }
  });
}

if (Array.isArray(filters.worker_ids) && filters.worker_ids.length > 0) {
  filters.worker_ids.forEach((id) => {
    if (id !== null && id !== undefined && id !== "") {
      queryParams.append("worker_ids", String(id));
    }
  });
}

if (filters.shift) queryParams.append("shift", filters.shift);

if (filters.salary !== "" && filters.salary !== null && filters.salary !== undefined) {
  queryParams.append("salary", String(filters.salary));
}

if (filters.work_hours !== "" && filters.work_hours !== null && filters.work_hours !== undefined) {
  queryParams.append("work_hours", String(filters.work_hours));
}
    const url = `${BASE_URL}/company-admins/workers?${queryParams.toString()}`;

    console.log("📡 Workers Export API URL:", url);

    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${decryptedToken}` },
    });

    const json = await res.json();

    if (json.error) {
      toast.error(json.message || "Failed to fetch workers");
      return [];
    }

    const rows = (json.data?.workers || []).map((w) => ({
      id: w.id,
      name: `${w.first_name} ${w.last_name}`,
      email: w.email || "-",
      phone: w.phone || "-",
      department: w.department_name || "-",
      type: w.employee_type || "-",
      shift: w.shift_schedule || "-",
      status: w.status || "-",
      date: w.created_at
        ? new Date(w.created_at).toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            // hour: "2-digit",
            // minute: "2-digit",
            // hour12: true,
          })
        : "—",
    }));

    return rows;
  } catch (err) {
    console.error("❌ Fetch all workers error:", err);
    toast.error("Something went wrong fetching all workers.");
    return [];
  }
};
const [deleteOpen, setDeleteOpen] = useState(false);
const [deleteLoading, setDeleteLoading] = useState(false);
const [deleteWorker, setDeleteWorker] = useState(null);
// delete API
const handleDeleteWorker = async () => {
  if (!deleteWorker) return;
  setDeleteLoading(true);

  try {
    const res = await fetch(`${BASE_URL}/company-admins/admin/workers/${deleteWorker.id}/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
    });

    const json = await res.json();

    if (res.ok && !json.error) {
      toast.success(t("toast.workerDeleted"));
      setWorkers((prev) => prev.filter((w) => w.id !== deleteWorker.id));
      setDeleteOpen(false);
    } else {
      toast.error(json.message || t("toast.workerDeleteFailed"));
    }
  } catch (err) {
    console.error("Error deleting worker:", err);
    toast.error(t("toast.workerDeleteNetworkError"));
  } finally {
    setDeleteLoading(false);
  }
};

// open modal from menu
const handleDeleteClick = () => {
  setDeleteWorker(menuWorker);
  setDeleteOpen(true);
  handleMenuClose();
};

const isEmpty =
  !initialLoading &&
  !tableLoading &&
  !errorMsg &&
  workers.length === 0;

const getWorkerStatusOptions = (currentStatus) => {
  switch ((currentStatus || "").toLowerCase()) {
    case "pending":
      return ["active", "inactive"];
          case "invited":
      return ["active", "inactive"];

    case "active":
      return ["inactive"];

    case "inactive":
      return ["active"];

    default:
      return [];
  }
};


const { logoBase64, loading } = useCompanyProfile(decryptedToken);
  console.log("HOOK LOGO:", logoBase64?.substring(0, 40));
  console.log("HOOK LOADING:", loading);


const [liveAttendance, setLiveAttendance] = useState(null);
  const [liveLoading, setLiveLoading] = useState(true);
  const [liveError, setLiveError] = useState(null);
  const [unvalidatedCount, setUnvalidatedCount] = useState(0);
  const {
    inboxCount = 0,
    accountExecutiveCount = 0,
    superAdminCount = 0,
  } = useSelector((state) => state.messageCount || {});
  const totalMessageCount = inboxCount + accountExecutiveCount + superAdminCount;
   useEffect(() => {
      const fetchLiveAttendance = async () => {
        if (!decryptedToken) return;
        setLiveLoading(true);
        setLiveError(null);
        try {
          const res = await fetch(`${BASE_URL}/company-admins/attendance/today`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${decryptedToken}`,
            },
          });
          const json = await res.json();
          if (json?.error) {
            setLiveError(json?.message || "Failed to fetch live attendance");
          } else {
            setLiveAttendance(json?.data || null);
          }
        } catch (err) {
          console.error("Error fetching live attendance:", err);
          setLiveError("Network error while fetching live attendance");
        } finally {
          setLiveLoading(false);
        }
      };
  
      fetchLiveAttendance();
    }, [decryptedToken]);
  useEffect(() => {
    const fetchUnvalidatedCount = async () => {
      if (!decryptedToken) return;
      try {
        const res = await fetch(
          `${BASE_URL}/company-admins/attendance/unvalidated?no_pagination=true&status=PENDING`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );
        const json = await res.json();
        if (!json?.error && json?.data?.punches) {
          setUnvalidatedCount(json.data.punches.length || 0);
        }
      } catch (err) {
        console.error("Error fetching unvalidated count:", err);
      }
    };

    fetchUnvalidatedCount();
  }, [decryptedToken]);
  const safeNum = (val) => (typeof val === "number" ? val : "-");
    const navigateWithStatus = (statusKey) => {
  navigate("/todays-logs", {
    state: { fromDashboard: true, initialStatus: statusKey }
  });
};
   const counters = liveAttendance?.counters || {};

  return (
    <>
            {fromDashboard && (
    <Box
      sx={{
        border: '1px solid #E4E6EF',
        borderRadius: 2,
        px: 2,
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minHeight: 55,
        mb: 2,
        ml:1, mr:1
      }}
    >
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
        onClick={() => navigate(-1)}
      >
        <img src={back} style={{ width: 30, height: 30 }} />
        <CustomText
          sx={{
            ...textStyles.h1,
            fontWeight: 500,
            fontSize: '14px',
            color: '#626F86',
            textAlign: 'center'
          }}
        >
          {t('companyAdmin')} 
        </CustomText>
      </Box>
    </Box>
  )}
  <Box
    sx={{
      backgroundColor: "white",
      borderRadius: 2,
      py: 2,
      ml: 1,
      mr: 1,
      mt: 1,
      border: selectedWorker ? "none" : "2px solid #091E4224",
      minHeight: "400px",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {initialLoading ? (
      <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    ) : selectedWorker ? (
      <WorkerDetails worker={selectedWorker} onBack={() => setSelectedWorker(null)} />
    ) : (
      <>



<Box
  sx={{
    display: "grid",
    px:2,
    gap: 1,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(5, 1fr)", // show all six in a row on large screens
      xl: "repeat(5, 1fr)",
    },
  }}
>
<DashboardCard
    icon={icon1}
    title={t("activeEmployeeRegistration")}
    description={liveLoading ? "…" : safeNum(counters.activeEmployeeRegistration)}
    onClick={() => navigate("/all-employees", { state: { fromDashboard: true, filterStatus: "active" } })}
    cardSx={{cursor:"pointer"}}
  />

<DashboardCard
    icon={icon2}
    title={t("ClockIn")}
    description={liveLoading ? "…" : safeNum(counters.employeePresentToday)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}
    cardSx={{cursor:"pointer"}}
  />


  <DashboardCard
    icon={icon3}
    title={t("ClockOut")}
    description={liveLoading ? "…" : safeNum(counters.clockout)}
       onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />
<DashboardCard
    icon={icon4}
    title={t("break_start")}
    description={liveLoading ? "…" : safeNum(counters.breakStart)}
       onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />

<DashboardCard
    icon={icon5}
    title={t("break_end")}
    description={liveLoading ? "…" : safeNum(counters.breakEnd)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />

  {/* 1. Pending Employee Registration */}


  {/* 2. Active Employee Registration */}


  {/* 3. Clock In today */}


  {/* 4. On Time Clock In today */}
  {/* <DashboardCard
    icon={ontimeclockin}
    title={t("OnTimeClockIn")}
    description={liveLoading ? "…" : safeNum(counters.employeeArrivingOnTime)}
       onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  /> */}

  {/* 5. Late Clock In today */}


  {/* 6. Start Break today */}






</Box>


   <Box
  sx={{
    display: "grid",
    gap: 1,
    mt:1.5,
    px:2,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(5, 1fr)", // show all six in a row on large screens
      xl: "repeat(5, 1fr)",
    },
  }}
>
 
<DashboardCard
    icon={icon6}
    title={t("LateClockIn")}
    description={liveLoading ? "…" : safeNum(counters.employeeArrivingLate)}
       onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />
<DashboardCard
    icon={icon7}
    title={t("LateClockOut")}
    description={liveLoading ? "…" : safeNum(counters.lateClockOut)}
        onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />


<DashboardCard
    icon={icon8}
    title={"Early Clock In"}
    description={liveLoading ? "…" : safeNum(counters.earlyClockIn)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true } })}
    cardSx={{ cursor: "pointer" }}
  />

  <DashboardCard
    icon={icon9}
    title={t("attendanceStatus.early_clock_out")}
    description={liveLoading ? "…" : safeNum(counters.earlyOut ?? counters.earlyClockOut)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true, initialStatus: "earlyOut" } })}
    cardSx={{ cursor: "pointer" }}
  />


<DashboardCard
    icon={icon10}
    title={t("employees_absent")}
    description={liveLoading ? "…" : safeNum(counters.employeeAbsent)}
            onClick={() => navigate("/absence", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />

  

  {/* 7. End Break today */}

  {/* 8. Clock Out today */}


  {/* 9. On Time Clock Out today */}

  {/* <DashboardCard
    icon={ontimeclockin}
    title={t("OnTimeClockOut") || "On Time Clock Out"}
    description={liveLoading ? "…" : safeNum(onTimeClockOut)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  /> */}

  {/* 10. Late Clock Out today */}

  {/* 11. Absences today */}


  {/* 12. Pending tasks */}

</Box>

   <Box
  sx={{
    display: "grid",
    gap: 1,
    px:2,
    mt: 1.5,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(5, 1fr)",
      xl: "repeat(5, 1fr)",
    },
  }}
>

<DashboardCard
    icon={icon11}
    title={t("unvalidatedPunches.title") || "Unvalidated Records"}
    description={unvalidatedCount}
    onClick={() => navigate("/unvalidated-punches", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />


<DashboardCard
    icon={icon12}
    title={"Validated Punches"}
    description={liveLoading ? "…" : safeNum(counters.validatedPunches)}
    onClick={() => navigate("/unvalidated-punches", { state: { fromDashboard: true } })}
    cardSx={{ cursor: "pointer" }}
  />


<DashboardCard
    icon={icon13}
    title={"Day Leave"}
    description={liveLoading ? "…" : safeNum(counters.dayLeave)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true } })}
    cardSx={{ cursor: "pointer" }}
  />

  <DashboardCard
    icon={icon14}
    title={"Half Day Leave"}
    description={liveLoading ? "…" : safeNum(counters.halfDayLeave)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true } })}
    cardSx={{ cursor: "pointer" }}
  />

<DashboardCard
    icon={icon15}
    title={t("pendingTask")}
    description={liveLoading ? "…" : safeNum(counters.pendingTask)}
    onClick={() => navigate("/all-tasks", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />


  {/* 14. Employee requests */}


  {/* 15. Employee documents */}


  {/* 16. Reimbursement requests */}


  {/* 17. Unvalidated records */}

</Box>

  <Box
  sx={{
    display: "grid",
    gap: 1,
    px:2,
    mt: 1.5,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(5, 1fr)",
      xl: "repeat(5, 1fr)",
    },
  }}
>
<DashboardCard
    icon={icon16}
    title={t("pendingRequests")}
    description={liveLoading ? "…" : safeNum(counters.pendingRequests)}
    onClick={() => navigate("/request-management", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />

<DashboardCard
    icon={icon17}
    title={t("pendingReimbursementRequests")}
    description={liveLoading ? "…" : safeNum(counters.pendingReimbursementRequests)}
    onClick={() => navigate("/Reimbursement-request", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />
  <DashboardCard
    icon={icon18}
    title={t("pendingReceivedDocuments")}
    description={liveLoading ? "…" : safeNum(counters.pendingReceivedDocuments)}
    onClick={() => navigate("/worker-documents", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />

<DashboardCard
    icon={icon19}
    title={t("pendingEmployeeRegistrations")}
    description={liveLoading ? "…" : safeNum(counters.pendingEmployeeRegistration)}
    onClick={() => navigate("/all-employees", { state: { fromDashboard: true, filterStatus: "pending" } })}
    cardSx={{cursor:"pointer"}}
  />
  {/* 13. Employee messages */}
  <DashboardCard
    icon={icon20}
    title={t("sidebar.messages")}
    description={totalMessageCount}
    onClick={() => navigate("/messages", { state: { fromDashboard: true, } })}

    cardSx={{cursor:"pointer"}}
  />
</Box>

        <Box sx={{ml:1, mr:1, mt:0,mb:4,}}>
    <WorkerPins
      companyId={companyId}
      statusFilter={filters.status}   
      page={page + 1}
      limit={pageSize}
      selectedWorkerId={selectedMapWorkerId}
      onClearFilter={handleClearMapFilter}
    />
      </Box>


        {/* Header Actions */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: isMobile ? "wrap" : "nowrap",
            pb: 2,
            px: 2,
            pt: 4,
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CustomText sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149" }}>
              {t("workers.manageWorkers")}
            </CustomText>
            {tableLoading && <CircularProgress size={20} sx={{ color: primaryColor }} />}
          </Box>

          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <SearchInput
              placeholder={t("workers.searchPlaceholder")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>

          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: 1,   }}>


  <ExportDropdown
    onDownloadPDF={async () => {
      console.log("CLICKED PDF EXPORT");   // <== Must print now

      if (loading) {
        console.log("PROFILE STILL LOADING");
        return;
      }

      if (!logoBase64) console.log("NO LOGO FOUND");

      const allData = await fetchAllWorkers();

      const blobStream = pdf(
        <ExportWorkersPDF data={allData} logo={logoBase64} />
      ).toBlob();

      blobStream.then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Workers_${new Date()
          .toISOString()
          .slice(0, 10)}.pdf`;
        link.click();
      });
    }}
    onDownloadExcel={async () => {
    const allData = await fetchAllWorkers(); // 👈 fetches full + filtered
    ExportWorkersExcel(allData);
  }}
  />
            <Button
              onClick={() => setOpenDrawer(true)}
              variant="contained"
              size="small"
              sx={{
                px: 2,
                backgroundColor: primaryColor,
                height: 32,
                fontSize: 14,
                fontWeight: 400,
                fontFamily: "Poppins, sans-serif",
                borderRadius: "4px",
                textTransform: "none",
              }}
              startIcon={<AddIcon sx={{ fontSize: 18 }} />}
            >
              {t("common.add")}
            </Button>


            {isFilterApplied ? (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: primaryColor, // dynamic background
    }}
  >
    {/* Filter Icon (white) */}
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Cross Icon (top-right corner) */}
    <IconButton
      size="small"
      onClick={() => {
        setFilters({ status: "", startDate: "", department_id: [],
  worker_ids: [],
  salary: "",
  shift: "",
  work_hours: "", });
        setPage(0);
      }}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { bgcolor: "#f5f5f5" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterDrawerOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
    }}
  >
    <FilterAltIcon />
  </IconButton>
)}

          </Box>
        </Box>

        {/* ✅ Error / Empty state check (keep header + add button visible) */}
        {errorMsg ? (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 5,
            }}
          >
            <img src={empty} alt="Error" style={{ width: 200, marginBottom: 16 }} />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: "16px",
                color: "#003149",
              }}
            >
              {errorMsg}
            </CustomText>
          </Box>
        ) : isEmpty ? (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 5,
            }}
          >
            <img src={empty} alt="No Data" style={{ width: 200, marginBottom: 16 }} />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: "16px",
                color: "#003149",
              }}
            >
              {t("empty.no_user")}
            </CustomText>
          </Box>
        ) : (
          <>
            {/* Table */}
            <TableContainer component={Paper} sx={{ boxShadow: "none", width: "100%", overflowX: "auto" }}>
              <Table sx={{ minWidth: "700px" }}>
                <TableHead sx={{ borderTop: "2px solid #091E4224", borderBottom: "2px solid #091E4224" }}>
                  <TableRow>
                    <TableCell sx={{ ...HaederStyles, pl: 1.5 }} onClick={() => handleSort("id")}>
                      {/* <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                        {t("common.id")} 
                      </Box> */}
                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
    {t("common.id")}

  </Box>
                    </TableCell>
                    <TableCell sx={HaederStyles} onClick={() => handleSort("name")}>
                      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                        {t("common.workerName")} 
                      </Box>
                    </TableCell>
                    <TableCell sx={HaederStyles}>{t("common.email")}</TableCell>
                    <TableCell sx={HaederStyles}>{t("common.phoneNo")}</TableCell>
                    <TableCell sx={HaederStyles}>{t("common.department")}</TableCell>
                    <TableCell sx={HaederStyles}>{t("common.type")}</TableCell>
                    <TableCell sx={HaederStyles}>{t("common.shift")}</TableCell>
                    <TableCell sx={HaederStyles}>{t("salary") || "Salary"}</TableCell>
<TableCell sx={HaederStyles}>{t("workHours") || "Work Hours"}</TableCell>
                    <TableCell sx={HaederStyles}>{t("common.status")}</TableCell>
                    {/* <TableCell sx={HaederStyles} onClick={() => handleSort("created_at")}>
                      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                        {t("common.registered")} 
                      </Box>
                    </TableCell> */}
  <TableCell sx={HaederStyles}>
  <Box
    onClick={() => handleSort("created_at")}
    sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}
  >
    {t("RegisteredOn")}
    {sortBy === "created_at" && (
      sortOrder === "asc" ? (
        <ArrowUpwardIcon sx={{ fontSize: 12,  }} />
      ) : (
        <ArrowDownwardIcon sx={{ fontSize: 12, }} />
      )
    )}
  </Box>
</TableCell>

                    <TableCell sx={HaederStyles}>{t("common.action")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {workers.map((row) => (
                    <TableRow 
                      key={row.id}
                      onClick={() => handleRowClick(row)}
                      sx={{ cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                    >
                      <TableCell sx={{ ...DataStyles, pl: 1.5 }}>{row.id}</TableCell>
                      <TableCell sx={DataStyles}>{row.name}</TableCell>
                      <TableCell sx={DataStyles}>{row.email}</TableCell>
                      <TableCell sx={DataStyles}>{row.phone ||"_"}</TableCell>
                      <TableCell sx={DataStyles}>{row.department}</TableCell>
                      <TableCell sx={DataStyles}>{row.type}</TableCell>
                      <TableCell sx={DataStyles}>{row.shift}</TableCell>
                      <TableCell sx={DataStyles}>{row.salary}</TableCell>
<TableCell sx={DataStyles}>{row.workHours}</TableCell>
                      <TableCell>
                        {/* <Box sx={{ pointerEvents: "none" }}> */}
                          {/* <WorkerStatusDropdown currentStatus={row.status} statusOptions={}/> */}
  <WorkerStatusDropdown
    currentStatus={row.status}
  statusOptions={getWorkerStatusOptions(row.status)}
    onChange={(newStatus) => handleStatusUpdate(row.id, newStatus, row.status)}
  />
                        {/* </Box> */}
                      </TableCell>
                      <TableCell sx={DataStyles}>{row.date}</TableCell>
                      <TableCell>
                        <IconButton size="small" onClick={(e) => handleMenuOpen(e, row)}>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", mt: 2 }}>
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={(e, value) => setPage(value - 1)}
                shape="rounded"
                color="primary"
                size="small"
                sx={{
                  "& .MuiPaginationItem-root": {
                    fontFamily: "Poppins, sans-serif",
                    fontSize: 13,
                    fontWeight: 500,
                  },
                  "& .Mui-selected": {
                    backgroundColor: `${primaryColor}10`,
                    color: primaryColor,
                  },
                }}
              />
            </Box>
          </>
        )}

        {/* Row action menu */}
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MenuItem onClick={handleView} sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}>
            {t("common.view")}
          </MenuItem>
            <MenuItem onClick={handleChat} sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}>
            {t("chat")}
          </MenuItem>
          <MenuItem onClick={handleEdit} sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}>
            {t("common.edit")}
          </MenuItem>
          <MenuItem
            onClick={handleDeleteClick}
            sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif", }}
          >
            {t("common.delete")}
          </MenuItem>
        </Menu>

        <FilterDrawer
          open={filterDrawerOpen}
          onClose={() => setFilterDrawerOpen(false)}
          filters={filters}
          setFilters={setFilters}
          onApplyFilters={(nextFilters) => {
            setFilters(nextFilters);
            setPage(0);
          }}
        />

        <AddWorkers
          open={openDrawer}
          onClose={() => {
            setOpenDrawer(false);
            setWorkerToEdit(null);
          }}
          onSuccess={() => {
            fetchWorkers();
            setWorkerToEdit(null);
          }}
          workerToEdit={workerToEdit}
        />
        {/* Schedule Modal for Pending to Active Status Change */}
        <Dialog
          open={scheduleModalOpen}
          onClose={() => {
            setScheduleModalOpen(false);
            setPendingWorker(null);
            setPendingNewStatus(null);
            setScheduleData(null);
            setScheduleForm({
              workingDays: [],
              startTime: "",
              endTime: "",
              graceMinutes: "",
              breakMinutes: "",
              locationName: "",
              radiusMeters: 100,
            });
            setCurrentLocation(null);
            setSearchQuery("");
            setAddress("");
            setSearchOpen(false);
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ pb: 1.5 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 600, fontFamily: "Poppins, sans-serif" }}>
                {t("workerSchedule") || "Worker Schedule"}
              </CustomText>
              <IconButton 
                onClick={() => setScheduleModalOpen(false)} 
                size="small"
                sx={{ fontSize: "20px", color: "#666" }}
              >
                ×
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            {pendingWorker && (
              <Box sx={{ mb: 2.5, pb: 2, borderBottom: "1px solid #e0e0e0" }}>
                <Typography sx={{ fontSize: 14, color: "#666", mb: 0.5, fontFamily: "Poppins, sans-serif" }}>
                  <strong style={{ fontSize: "14px", color: "#172B4D" }}>{t("scheduleModal.workerInfo") || "Worker"}:</strong> {pendingWorker.name}
                </Typography>
                <Typography sx={{ fontSize: 14, color: "#666", lineHeight: 1.5, fontFamily: "Poppins, sans-serif" }}>
                  {t("scheduleModal.statusChange") || "Status will change from 'pending' to 'active'. Please review the schedule below."}
                </Typography>
              </Box>
            )}

            {scheduleLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                <CircularProgress size={24} />
              </Box>
            ) : (
              <Box>
                {scheduleData ? (
                  <Typography sx={{ fontSize: 14, mb: 2, color: "#666", fontStyle: "italic", fontFamily: "Poppins, sans-serif" }}>
                    {scheduleData.source === "worker" 
                      ? (t("scheduleModal.workerSchedule") || "Worker's existing schedule:")
                      : (t("scheduleModal.departmentSchedule") || "Department schedule (worker doesn't have a schedule):")}
                  </Typography>
                ) : (
                  <Typography sx={{ fontSize: 14, mb: 2, color: "#666", fontStyle: "italic", fontFamily: "Poppins, sans-serif" }}>
                    {t("scheduleModal.noSchedule") || "No schedule found. Please add a schedule for this worker:"}
                  </Typography>
                )}

                {/* Working Days */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: 14, mb: 1, fontWeight: 600, color: "#172B4D", fontFamily: "Poppins, sans-serif" }}>
                    {t("editModal.labels.workingDays") || "Working Days"}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                    {fullDays.map((day) => {
                      const short = day.slice(0, 3);
                      const isSelected = scheduleForm.workingDays.includes(short);
                      return (
                        <Box
                          key={day}
                          onClick={() => {
                            setScheduleForm((prev) => ({
                              ...prev,
                              workingDays: prev.workingDays.includes(short)
                                ? prev.workingDays.filter((d) => d !== short)
                                : [...prev.workingDays, short],
                            }));
                          }}
                          sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: 600,
                            userSelect: "none",
                            bgcolor: isSelected ? "#1976d2" : "#e0e0e0",
                            color: isSelected ? "#fff" : "#000",
                            transition: "all 0.2s",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          {day[0]}
                        </Box>
                      );
                    })}
                  </Box>
                </Box>

                {/* Shift Times */}
                <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
                  <TextField
                    label={t("editModal.labels.shiftStart") || "Shift Start"}
                    type="time"
                    value={scheduleForm.startTime}
                    onChange={(e) =>
                      setScheduleForm((prev) => ({ ...prev, startTime: e.target.value }))
                    }
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true, sx: { fontSize: "14px", fontFamily: "Poppins, sans-serif" } }}
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "14px", fontFamily: "Poppins, sans-serif", py: 1 },
                      "& .MuiOutlinedInput-root": { fontSize: "14px" },
                    }}
                  />
                  <TextField
                    label={t("editModal.labels.shiftEnd") || "Shift End"}
                    type="time"
                    value={scheduleForm.endTime}
                    onChange={(e) =>
                      setScheduleForm((prev) => ({ ...prev, endTime: e.target.value }))
                    }
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true, sx: { fontSize: "14px", fontFamily: "Poppins, sans-serif" } }}
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "14px", fontFamily: "Poppins, sans-serif", py: 1 },
                      "& .MuiOutlinedInput-root": { fontSize: "14px" },
                    }}
                  />
                </Box>

                {/* Grace + Break */}
                <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
                  <TextField
                    label={t("editModal.labels.graceMinutes") || "Grace Time (minutes)"}
                    type="number"
                    value={scheduleForm.graceMinutes}
                    onChange={(e) =>
                      setScheduleForm((prev) => ({ ...prev, graceMinutes: e.target.value }))
                    }
                    fullWidth
                    size="small"
                    inputProps={{ min: 0 }}
                    InputLabelProps={{ shrink: true, sx: { fontSize: "14px", fontFamily: "Poppins, sans-serif" } }}
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "14px", fontFamily: "Poppins, sans-serif", py: 1 },
                      "& .MuiOutlinedInput-root": { fontSize: "14px" },
                    }}
                  />
                  <TextField
                    label={t("editModal.labels.breakMinutes") || "Break Time (minutes)"}
                    type="number"
                    value={scheduleForm.breakMinutes}
                    onChange={(e) =>
                      setScheduleForm((prev) => ({ ...prev, breakMinutes: e.target.value }))
                    }
                    fullWidth
                    size="small"
                    inputProps={{ min: 0 }}
                    InputLabelProps={{ shrink: true, sx: { fontSize: "14px", fontFamily: "Poppins, sans-serif" } }}
                    sx={{
                      "& .MuiInputBase-input": { fontSize: "14px", fontFamily: "Poppins, sans-serif", py: 1 },
                      "& .MuiOutlinedInput-root": { fontSize: "14px" },
                    }}
                  />
                </Box>

                {/* Location Name */}
                <TextField
                  label={t("editModal.labels.locationName") || "Location Name"}
                  value={scheduleForm.locationName}
                  onChange={(e) =>
                    setScheduleForm((prev) => ({ ...prev, locationName: e.target.value }))
                  }
                  fullWidth
                  size="small"
                  sx={{ 
                    mb: 2,
                    "& .MuiInputBase-input": { fontSize: "14px", fontFamily: "Poppins, sans-serif", py: 1 },
                    "& .MuiOutlinedInput-root": { fontSize: "14px" },
                  }}
                  InputLabelProps={{ shrink: true, sx: { fontSize: "14px", fontFamily: "Poppins, sans-serif" } }}
                />

                {/* Radius */}
                <TextField
                  label={t("editModal.labels.locationRadius") || "Location Radius (meters)"}
                  type="number"
                  value={scheduleForm.radiusMeters}
                  onChange={(e) =>
                    setScheduleForm((prev) => ({ ...prev, radiusMeters: e.target.value }))
                  }
                  fullWidth
                  size="small"
                  inputProps={{ min: 0 }}
                  InputLabelProps={{ shrink: true, sx: { fontSize: "14px", fontFamily: "Poppins, sans-serif" } }}
                  sx={{
                    "& .MuiInputBase-input": { fontSize: "14px", fontFamily: "Poppins, sans-serif", py: 1 },
                    "& .MuiOutlinedInput-root": { fontSize: "14px" },
                    mb: 2,
                  }}
                />

                {/* Map Display */}
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#172B4D", fontFamily: "Poppins, sans-serif" }}>
                      {t("editModal.map.location") || "Location"}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 0.5 }}>
                      <IconButton
                        onClick={() => setSearchOpen((p) => !p)}
                        size="small"
                        sx={{
                          backgroundColor: "#1976d2",
                          color: "#fff",
                          width: 28,
                          height: 28,
                          "&:hover": { backgroundColor: "#115293" },
                        }}
                      >
                        <SearchIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                      <IconButton
                        onClick={handleGetCurrentLocation}
                        size="small"
                        sx={{
                          backgroundColor: "#4caf50",
                          color: "#fff",
                          width: 28,
                          height: 28,
                          "&:hover": { backgroundColor: "#388e3c" },
                        }}
                      >
                        <MyLocationIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Box>
                  </Box>

                  {/* Search input */}
                  {searchOpen && (
                    <Box sx={{ mb: 1.5, position: "relative" }}>
                      <input
                        type="text"
                        placeholder={t("searchLocationPlaceholder") || "Search location..."}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px",
                          fontSize: "12px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          fontFamily: "Poppins, sans-serif",
                          outline: "none",
                        }}
                      />
                      {searchSuggestions.length > 0 && (
                        <Box
                          sx={{
                            position: "absolute",
                            zIndex: 1000,
                            background: "#fff",
                            width: "100%",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            mt: 0.5,
                            maxHeight: 200,
                            overflowY: "auto",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          }}
                        >
                          {searchSuggestions.map((sug, idx) => (
                            <Box
                              key={idx}
                              sx={{
                                p: 1,
                                cursor: "pointer",
                                fontSize: "11px",
                                fontFamily: "Poppins, sans-serif",
                                "&:hover": { backgroundColor: "#f5f5f5" },
                              }}
                              onClick={() => handleSearchSelect(sug)}
                            >
                              {sug.description}
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                  )}

                  {currentLocation ? (
                    <>
                      <Box sx={{ fontSize: 11, color: "#666", mb: 1, fontFamily: "Poppins, sans-serif" }}>
                        <strong>Lat:</strong> {currentLocation[0].toFixed(6)}, <strong>Lng:</strong> {currentLocation[1].toFixed(6)}
                      </Box>
                      <Box sx={{ height: 200, borderRadius: "8px", overflow: "hidden", border: "1px solid #e0e0e0", mb: 1 }}>
                        <GoogleMap
                          mapContainerStyle={mapContainerStyle}
                          center={{ lat: currentLocation[0], lng: currentLocation[1] }}
                          zoom={15}
                        >
                          <Marker
                            position={{ lat: currentLocation[0], lng: currentLocation[1] }}
                            draggable
                            icon={getGoogleMapsPinIconFromHex(primaryColor || "#006EC2")}
                            onDragEnd={(e) => {
                              const coords = [e.latLng.lat(), e.latLng.lng()];
                              setCurrentLocation(coords);
                              fetchAddress(coords);
                            }}
                          />
                          <Circle
                            center={{ lat: currentLocation[0], lng: currentLocation[1] }}
                            radius={Number(scheduleForm.radiusMeters) || 100}
                            options={{
                              fillColor: primaryColor || "#006EC2",
                              fillOpacity: 0.2,
                              strokeColor: primaryColor || "#006EC2",
                              strokeOpacity: 0.8,
                              strokeWeight: 2,
                            }}
                          />
                        </GoogleMap>
                      </Box>
                      {address && (
                        <Box
                          component="textarea"
                          readOnly
                          value={address}
                          sx={{
                            width: "100%",
                            padding: "8px 12px",
                            fontSize: "11px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "6px",
                            backgroundColor: "#f5f5f5",
                            fontFamily: "Poppins, sans-serif",
                            resize: "vertical",
                            overflowY: "auto",
                            lineHeight: 1.4,
                            minHeight: "40px",
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <Box sx={{ py: 2, textAlign: "center", color: "#999", fontSize: "11px", fontFamily: "Poppins, sans-serif" }}>
                      {t("editModal.map.fetching") || "No location set. Use search or current location button."}
                    </Box>
                  )}
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2, pt: 1.5, borderTop: "1px solid #e0e0e0" }}>
            <Button
              onClick={() => {
                setScheduleModalOpen(false);
                setPendingWorker(null);
                setPendingNewStatus(null);
                setScheduleData(null);
                setScheduleForm({
                  workingDays: [],
                  startTime: "",
                  endTime: "",
                  graceMinutes: "",
                  breakMinutes: "",
                  locationName: "",
                  radiusMeters: 100,
                });
                setCurrentLocation(null);
                setSearchQuery("");
                setAddress("");
                setSearchOpen(false);
              }}
              sx={{ 
                fontSize: "12px", 
                fontFamily: "Poppins, sans-serif",
                textTransform: "none",
                color: "#666",
                "&:hover": { backgroundColor: "#f5f5f5" }
              }}
            >
              {t("common.cancel") || "Cancel"}
            </Button>
            <Button
              variant="contained"
              onClick={handleScheduleConfirm}
              disabled={scheduleLoading}
              sx={{ 
                backgroundColor: primaryColor, 
                color: primaryTextColor,
                fontSize: "12px",
                fontFamily: "Poppins, sans-serif",
                textTransform: "none",
                px: 2,
                "&:hover": { backgroundColor: secondaryColor, color: secondaryTextColor },
                "&:disabled": { opacity: 0.6 }
              }}
            >
              {t("scheduleModal.confirmAndActivate") || "Confirm & Activate"}
            </Button>
          </DialogActions>
        </Dialog>

        <DeleteWorkerModal
  open={deleteOpen}
  onClose={() => setDeleteOpen(false)}
  onConfirm={handleDeleteWorker}
  loading={deleteLoading}
  worker={deleteWorker}
/>
      </>
    )}
  </Box>
  </>
  );
};

export default AllWorkers;












